import React from 'react';

import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import BdsCardContainer from '../../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import ErrorCard from '../../../../../shared/components/v3/Cards/ErrorCard/ErrorCard';
import BdsDivider from '../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { TRANSLATION_COLLABORATORS } from '../../../../../shared/translations/collaborators';
import { TRANSLATIONS_GLOBAL } from '../../../../../shared/translations/commons';
import { GenericVoidFunction } from '../../../../../shared/types/genericTypes';

import './ReadOnlyDataCard.scss';

export interface IReadOnlyField {
  label: string;
  value: string | null;
}

interface IReadOnlyDataCard {
  title: string;
  fields: IReadOnlyField[];
  isLoading: boolean;
  isError: boolean;
  onRetry: GenericVoidFunction;
}

const ReadOnlyDataCard = ({ title, fields, isLoading, isError, onRetry }: IReadOnlyDataCard) => {
  const { t } = useTranslation();

  if (isError) {
    return (
      <div className="flex flex-col justify-center items-center w-full">
        <ErrorCard
          primaryText={t(TRANSLATIONS_GLOBAL.errorCard.title)}
          secondaryText={t(TRANSLATIONS_GLOBAL.errorCard.description)}
          center={true}
          action={onRetry}
          className="flex flex-col justify-center items-center"
          buttonText={t(TRANSLATIONS_GLOBAL.errorCard.buttonText)}
        />
      </div>
    );
  }

  return (
    <BdsCardContainer
      className="collaborator-read-only-data-card flex flex-col w-full"
      paddingSize="padding-l"
      type="solid"
      borderRadiusSize="radius-l"
    >
      <div className="top flex flex-row justify-between w-full">
        <div className="title">{t(title)}</div>
      </div>
      {isLoading ? (
        <Skeleton animation={false} className="skeleton" variant="rectangular" />
      ) : (
        <div className="fields">
          {fields.map(({ label, value }) => (
            <div key={label} className="view-data flex flex-col w-full text-start align-start">
              <span className="label">{t(label)}</span>
              <span className={`data ${value === null ? 'no-data' : ''}`}>
                {value ?? t(TRANSLATION_COLLABORATORS.detail.contractDetails.pending)}
              </span>
              <BdsDivider color="light" size="s" />
            </div>
          ))}
        </div>
      )}
    </BdsCardContainer>
  );
};

export default ReadOnlyDataCard;
